import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";
import Tabla from "components/Tabla";
import EditIcon from "@material-ui/icons/Edit";

const SolicitudesFechas = ({
  idtablero,
  setCargando,
  setMensaje,
  cargarTablero,
  ...props
}) => {
  const classesTablero = useStylesTablero();
  const [data, setData] = useState([]);

  const handleActualizar = (solicitud) => {
    
    serviciosTablero.cambiarEstatusSolicitud(
        (estatus, mensaje, data) => {
          if (estatus > 0) {
            setData(data);
            setMensaje({
                open: true,
                status: 2,
                value: "La solicitud de cambio de fecha fue autorizada.",
              });
            cargarTablero();
          }
        },
        setCargando,
        { idsolicitud: solicitud.idsolicitud,idestatus: 2, idtablero:idtablero }
      );
  };
  
  const handleRechazar = (solicitud) => {
    serviciosTablero.cambiarEstatusSolicitud(
      (estatus, mensaje, data) => {
        if (estatus > 0) {
          setData(data);
          setMensaje({
              open: true,
              status: 0,
              value: "La solicitud de cambio de fecha fue rechazada.",
            });
        }
      },
      setCargando,
      { idsolicitud: solicitud.idsolicitud,idestatus: 0 ,idtablero:idtablero}
    );
  };
  const columnas = [
    { label: "Folio", name: "idsolicitud", filtrar: true },
    { label: "Tarjeta", name: "titulo", filtrar: true },
    { label: "Motivo", name: "nmotivo", filtrar: true },
    { label: "Fechas anteriores", name: "fechasAntiguas", filtrar: true },
    { label: "Fechas nuevas", name: "fechasNuevas", filtrar: true },
    { label: "Solicitante", name: "nombreSol", filtrar: true },
    { label: "Fecha de solicitud", name: "fcrea", filtrar: true },
  ];
  const accionesFila = [
    {
      label: "Autorizar",
      onClick: handleActualizar,
      enabled: true,
      icon: <EditIcon />,
    },{
        label: "Rechazar",
        onClick: handleRechazar,
        enabled: true,
        icon: <EditIcon />,
      },
  ];
  const getSolicitudes = () => {
    serviciosTablero.getSolicitudesPendientesFechas(
      (estatus, mensaje, data) => {
        if (estatus > 0) {
          setData(data);
        }
      },
      setCargando,
      { idtablero: idtablero }
    );
  };
  // Manejar la acción de aceptar

  // Manejar la acción de declinar
  
  useEffect(() => {
    getSolicitudes();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid xs={12}>
        <Tabla
          columns={columnas}
          rows={data}
          usarEstilosTablero={true}
          accionesFila={accionesFila}
        />
      </Grid>
    </Grid>
  );
};

export default SolicitudesFechas;
